/**
 * RESPONSIBILITY: the Leadership page's head.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { ABOVE_HINT } from '../hints';

@Section({ name: SectionName.LeadershipHero, label: 'Leadership — page head' })
export class LeadershipHeroSection {
  @Text({ label: 'Subtitle', maxLength: 120, default: 'About', description: ABOVE_HINT })
  eyebrow!: string;

  @Text({ label: 'Title', maxLength: 300, default: 'Leadership' })
  heading!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 2 })
  intro!: string;
}
